import { defineCopy } from "@tami/core/intl";

import { DASHBOARD_SCRIPT_COPY_EN_US } from "./en-us/dashboard-script.copy";
import { DASHBOARD_SCRIPT_COPY_ES_ES } from "./es-es/dashboard-script.copy";

export const DASHBOARD_SCRIPT_COPY_PT_BR = {
  dashIntro: {
    narrative:
      "Seu painel reúne desempenho, rotina e entregas — tudo o que importa para a sua carreira como creator.",
  },
  dashGreeting: {
    narrative:
      "Comece o dia sabendo exatamente o que precisa postar, entregar e resolver — sem abrir cinco apps diferentes.",
    callout:
      "Bom dia, Ana! Aqui você vê o resumo do seu dia num relance.",
  },
  dashOverview1: {
    narrative:
      "Menos planilha, menos caos — mais tempo para criar.",
  },
  dashSocial: {
    narrative:
      "Acompanhe a taxa de engajamento e a evolução dos seguidores em cada rede, sempre atualizados.",
    callout:
      "Instagram, TikTok e YouTube conectados — seguidores e engajamento lado a lado.",
  },
  dashOverview2: {
    narrative:
      "Gráficos simples de interpretar, com o desempenho das suas semanas.",
  },
  dashKpis: {
    narrative:
      "Receita, campanhas ativas, entregas pendentes e engajamento geral — monitorados automaticamente para você.",
    callout:
      "KPIs do mês em tempo real: receita, campanhas, entregas e engajamento.",
  },
  dashOverview3: {
    narrative:
      "Entenda seu desempenho ao longo das semanas, sem achismo.",
  },
  dashPosts: {
    narrative:
      "Tenha uma lista clara do que precisa ser postado hoje e na semana — com horário, plataforma e formato.",
    callout:
      "Publi e orgânico separados: saiba o que vai ao ar hoje e o que vem na semana.",
  },
  dashAgenda: {
    narrative:
      "Reuniões, gravações e compromissos do dia integrados à sua rotina — nada fica espalhado.",
    callout:
      "Agenda do dia sincronizada: calls, gravações e entregas num só lugar.",
  },
} as const;

export const DASHBOARD_SCRIPT_COPY = defineCopy(DASHBOARD_SCRIPT_COPY_PT_BR, {
  "en-US": DASHBOARD_SCRIPT_COPY_EN_US,
  "es-ES": DASHBOARD_SCRIPT_COPY_ES_ES,
});
